import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

import CadastroNotificacoes from './CadastroNotificacoes';

import AuthProvider from '../../AuthProvider';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera » Notificações » Configurações" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (containsRole(['admin', 'sindico', 'conselheiro', 'porteiro', 'zelador', 'morador', 'proprietario', 'agua-mineral'])) {
              children.push(CadastroNotificacoes);
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/notificacao/Configuracoes.js